import { EditorView as y, Decoration as g, hoverTooltip as q, showPanel as W, ViewPlugin as Z, logException as z, gutter as K, showTooltip as U, getPanel as X, WidgetType as J, GutterMarker as Q } from "./ghl-ui.es269.js";
import { StateField as P, Facet as M, combineConfig as F, RangeSet as E, StateEffect as w } from "./ghl-ui.es268.js";
import m from "./ghl-ui.es432.js";
class ee {
  constructor(e, n, i) {
    this.from = e, this.to = n, this.diagnostic = i;
  }
}
class u {
  constructor(e, n, i) {
    this.diagnostics = e, this.panel = n, this.selected = i;
  }
  static init(e, n, i) {
    let o = e, s = i.facet(h).markerFilter;
    s && (o = s(o));
    let l = g.set(o.map((r) => r.from == r.to || r.from == r.to - 1 && i.doc.lineAt(r.from).to == r.from ? g.widget({
      widget: new le(r),
      diagnostic: r
    }).range(r.from) : g.mark({
      attributes: { class: "cm-lintRange cm-lintRange-" + r.severity + (r.markClass ? " " + r.markClass : "") },
      diagnostic: r
    }).range(r.from, r.to)), !0);
    return new u(l, n, b(l));
  }
}
function b(t, e = null, n = 0) {
  let i = null;
  return t.between(n, 1e9, (o, s, { spec: l }) => {
    if (!(e && l.diagnostic != e))
      return i = new ee(o, s, l.diagnostic), !1;
  }), i;
}
function B(t, e) {
  let n = t.startState.doc.lineAt(e.pos);
  return !!(t.effects.some((i) => i.is(v)) || t.changes.touchesRange(n.from, n.to));
}
function O(t, e) {
  return t.field(f, !1) ? e : e.concat(w.appendConfig.of(Y));
}
function te(t, e) {
  return {
    effects: O(t, [v.of(e)])
  };
}
const v = /* @__PURE__ */ w.define(), R = /* @__PURE__ */ w.define(), G = /* @__PURE__ */ w.define(), f = /* @__PURE__ */ P.define({
  create() {
    return new u(g.none, null, null);
  },
  update(t, e) {
    if (e.docChanged) {
      let n = t.diagnostics.map(e.changes), i = null;
      if (t.selected) {
        let o = e.changes.mapPos(t.selected.from, 1);
        i = b(n, t.selected.diagnostic, o) || b(n, null, o);
      }
      t = new u(n, t.panel, i);
    }
    for (let n of e.effects)
      n.is(v) ? t = u.init(n.value, t.panel, e.state) : n.is(R) ? t = new u(t.diagnostics, n.value ? C.open : null, t.selected) : n.is(G) && (t = new u(t.diagnostics, t.panel, n.value));
    return t;
  },
  provide: (t) => [
    W.from(t, (e) => e.panel),
    y.decorations.from(t, (e) => e.diagnostics)
  ]
}), ie = /* @__PURE__ */ g.mark({ class: "cm-lintRange cm-lintRange-active" });
function ne(t, e, n) {
  let { diagnostics: i } = t.state.field(f), o = [], s = 2e8, l = 0;
  i.between(e - (n < 0 ? 1 : 0), e + (n > 0 ? 1 : 0), (c, d, { spec: a }) => {
    e >= c && e <= d && (c == d || (e > c || n > 0) && (e < d || n < 0)) && (o.push(a.diagnostic), s = Math.min(c, s), l = Math.max(d, l));
  });
  let r = t.state.facet(h).tooltipFilter;
  return r && (o = r(o)), o.length ? {
    pos: s,
    end: l,
    above: t.state.doc.lineAt(s).to < l,
    create() {
      return { dom: j(t, o) };
    }
  } : null;
}
function j(t, e) {
  return m("ul", { class: "cm-tooltip-lint" }, e.map((n) => $(t, n, !1)));
}
const oe = (t) => {
  let e = t.state.field(f, !1);
  (!e || !e.panel) && t.dispatch({ effects: O(t.state, [R.of(!0)]) });
  let n = X(t, C.open);
  return n && n.dom.querySelector(".cm-panel-lint ul").focus(), !0;
}, D = (t) => {
  let e = t.state.field(f, !1);
  return !e || !e.panel ? !1 : (t.dispatch({ effects: R.of(!1) }), !0);
}, se = (t) => {
  let e = t.state.field(f, !1);
  if (!e)
    return !1;
  let n = t.state.selection.main, i = e.diagnostics.iter(n.to + 1);
  return !i.value && (i = e.diagnostics.iter(0), !i.value || i.from == n.from && i.to == n.to) ? !1 : (t.dispatch({ selection: { anchor: i.from, head: i.to }, scrollIntoView: !0 }), !0);
}, we = [
  { key: "Mod-Shift-m", run: oe, preventDefault: !0 },
  { key: "F8", run: se }
], re = /* @__PURE__ */ Z.fromClass(class {
  constructor(t) {
    this.view = t, this.timeout = -1, this.set = !0;
    let { delay: e } = t.state.facet(h);
    this.lintTime = Date.now() + e, this.run = this.run.bind(this), this.timeout = setTimeout(this.run, e);
  }
  run() {
    let t = Date.now();
    if (t < this.lintTime - 10)
      this.timeout = setTimeout(this.run, this.lintTime - t);
    else {
      this.set = !1;
      let { state: e } = this.view, { sources: n } = e.facet(h);
      Promise.all(n.map((i) => Promise.resolve(i(this.view)))).then((i) => {
        let o = i.reduce((s, l) => s.concat(l));
        this.view.state.doc == e.doc && this.view.dispatch(te(this.view.state, o));
      }, (i) => {
        z(this.view.state, i);
      });
    }
  }
  update(t) {
    let e = t.state.facet(h);
    (t.docChanged || e != t.startState.facet(h) || e.needsRefresh && e.needsRefresh(t)) && (this.lintTime = Date.now() + e.delay, this.set || (this.set = !0, this.timeout = setTimeout(this.run, e.delay)));
  }
  force() {
    this.set && (this.lintTime = Date.now(), this.run());
  }
  destroy() {
    clearTimeout(this.timeout);
  }
}), h = /* @__PURE__ */ M.define({
  combine(t) {
    return Object.assign({ sources: t.map((e) => e.source) }, F(t.map((e) => e.config), {
      delay: 750,
      markerFilter: null,
      tooltipFilter: null,
      needsRefresh: null
    }, {
      needsRefresh: (e, n) => e ? n ? (i) => e(i) || n(i) : e : n
    }));
  }
});
function ke(t, e = {}) {
  return [
    h.of({ source: t, config: e }),
    re,
    Y
  ];
}
function H(t) {
  let e = [];
  if (t)
    e:
      for (let { name: n } of t) {
        for (let i = 0; i < n.length; i++) {
          let o = n[i];
          if (/[a-zA-Z]/.test(o) && !e.some((s) => s.toLowerCase() == o.toLowerCase())) {
            e.push(o);
            continue e;
          }
        }
        e.push("");
      }
  return e;
}
function $(t, e, n) {
  var i;
  let o = n ? H(e.actions) : [];
  return m("li", { class: "cm-diagnostic cm-diagnostic-" + e.severity }, m("span", { class: "cm-diagnosticText" }, e.renderMessage ? e.renderMessage() : e.message), (i = e.actions) === null || i === void 0 ? void 0 : i.map((s, l) => {
    let r = !1, c = (_) => {
      if (_.preventDefault(), r)
        return;
      r = !0;
      let S = b(t.state.field(f).diagnostics, e);
      S && s.apply(t, S.from, S.to);
    }, { name: d } = s, a = o[l] ? d.indexOf(o[l]) : -1, p = a < 0 ? d : [
      d.slice(0, a),
      m("u", d.slice(a, a + 1)),
      d.slice(a + 1)
    ];
    return m("button", {
      type: "button",
      class: "cm-diagnosticAction",
      onclick: c,
      onmousedown: c,
      "aria-label": ` Action: ${d}${a < 0 ? "" : ` (access key "${o[l]})"`}.`
    }, p);
  }), e.source && m("div", { class: "cm-diagnosticSource" }, e.source));
}
class le extends J {
  constructor(e) {
    super(), this.diagnostic = e;
  }
  eq(e) {
    return e.diagnostic == this.diagnostic;
  }
  toDOM() {
    return m("span", { class: "cm-lintPoint cm-lintPoint-" + this.diagnostic.severity });
  }
}
class A {
  constructor(e, n) {
    this.diagnostic = n, this.id = "item_" + Math.floor(Math.random() * 4294967295).toString(16), this.dom = $(e, n, !0), this.dom.id = this.id, this.dom.setAttribute("role", "option");
  }
}
class C {
  constructor(e) {
    this.view = e, this.items = [];
    let n = (o) => {
      if (o.keyCode == 27)
        D(this.view), this.view.focus();
      else if (o.keyCode == 38 || o.keyCode == 33)
        this.moveSelection((this.selectedIndex - 1 + this.items.length) % this.items.length);
      else if (o.keyCode == 40 || o.keyCode == 34)
        this.moveSelection((this.selectedIndex + 1) % this.items.length);
      else if (o.keyCode == 36)
        this.moveSelection(0);
      else if (o.keyCode == 35)
        this.moveSelection(this.items.length - 1);
      else if (o.keyCode == 13)
        this.view.focus();
      else if (o.keyCode >= 65 && o.keyCode <= 90 && this.selectedIndex >= 0) {
        let { diagnostic: s } = this.items[this.selectedIndex], l = H(s.actions);
        for (let r = 0; r < l.length; r++)
          if (l[r].toUpperCase().charCodeAt(0) == o.keyCode) {
            let c = b(this.view.state.field(f).diagnostics, s);
            c && s.actions[r].apply(e, c.from, c.to);
          }
      } else
        return;
      o.preventDefault();
    }, i = (o) => {
      for (let s = 0; s < this.items.length; s++)
        this.items[s].dom.contains(o.target) && this.moveSelection(s);
    };
    this.list = m("ul", {
      tabIndex: 0,
      role: "listbox",
      "aria-label": this.view.state.phrase("Diagnostics"),
      onkeydown: n,
      onclick: i
    }), this.dom = m("div", { class: "cm-panel-lint" }, this.list, m("button", {
      type: "button",
      name: "close",
      "aria-label": this.view.state.phrase("close"),
      onclick: () => D(this.view)
    }, "×")), this.update();
  }
  get selectedIndex() {
    let e = this.view.state.field(f).selected;
    if (!e)
      return -1;
    for (let n = 0; n < this.items.length; n++)
      if (this.items[n].diagnostic == e.diagnostic)
        return n;
    return -1;
  }
  update() {
    let { diagnostics: e, selected: n } = this.view.state.field(f), i = 0, o = !1, s = null;
    for (e.between(0, this.view.state.doc.length, (l, r, { spec: c }) => {
      let d = -1, a;
      for (let p = i; p < this.items.length; p++)
        if (this.items[p].diagnostic == c.diagnostic) {
          d = p;
          break;
        }
      d < 0 ? (a = new A(this.view, c.diagnostic), this.items.splice(i, 0, a), o = !0) : (a = this.items[d], d > i && (this.items.splice(i, d - i), o = !0)), n && a.diagnostic == n.diagnostic ? a.dom.hasAttribute("aria-selected") || (a.dom.setAttribute("aria-selected", "true"), s = a) : a.dom.hasAttribute("aria-selected") && a.dom.removeAttribute("aria-selected"), i++;
    }); i < this.items.length && !(this.items.length == 1 && this.items[0].diagnostic.from < 0); )
      o = !0, this.items.pop();
    this.items.length == 0 && (this.items.push(new A(this.view, {
      from: -1,
      to: -1,
      severity: "info",
      message: this.view.state.phrase("No diagnostics")
    })), o = !0), s ? (this.list.setAttribute("aria-activedescendant", s.id), this.view.requestMeasure({
      key: this,
      read: () => ({ sel: s.dom.getBoundingClientRect(), panel: this.list.getBoundingClientRect() }),
      write: ({ sel: l, panel: r }) => {
        let c = r.height / this.list.offsetHeight;
        l.top < r.top ? this.list.scrollTop -= (r.top - l.top) / c : l.bottom > r.bottom && (this.list.scrollTop += (l.bottom - r.bottom) / c);
      }
    })) : this.selectedIndex < 0 && this.list.removeAttribute("aria-activedescendant"), o && this.sync();
  }
  sync() {
    let e = this.list.firstChild;
    function n() {
      let i = e;
      e = i.nextSibling, i.remove();
    }
    for (let i of this.items)
      if (i.dom.parentNode == this.list) {
        for (; e != i.dom; )
          n();
        e = i.dom.nextSibling;
      } else
        this.list.insertBefore(i.dom, e);
    for (; e; )
      n();
  }
  moveSelection(e) {
    if (this.selectedIndex < 0)
      return;
    let n = this.view.state.field(f), i = b(n.diagnostics, this.items[e].diagnostic);
    i && this.view.dispatch({
      selection: { anchor: i.from, head: i.to },
      scrollIntoView: !0,
      effects: G.of(i)
    });
  }
  static open(e) {
    return new C(e);
  }
}
function x(t, e = 'viewBox="0 0 40 40"') {
  return `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" ${e}>${encodeURIComponent(t)}</svg>')`;
}
function k(t) {
  return x(`<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="${t}" fill="none" stroke-width=".7"/>`, 'width="6" height="3"');
}
const ae = /* @__PURE__ */ y.baseTheme({
  ".cm-diagnostic": {
    padding: "3px 6px 3px 8px",
    marginLeft: "-1px",
    display: "block",
    whiteSpace: "pre-wrap"
  },
  ".cm-diagnostic-error": { borderLeft: "5px solid #d11" },
  ".cm-diagnostic-warning": { borderLeft: "5px solid orange" },
  ".cm-diagnostic-info": { borderLeft: "5px solid #999" },
  ".cm-diagnostic-hint": { borderLeft: "5px solid #66d" },
  ".cm-diagnosticAction": {
    font: "inherit",
    border: "none",
    padding: "2px 4px",
    backgroundColor: "#444",
    color: "white",
    borderRadius: "3px",
    marginLeft: "8px",
    cursor: "pointer"
  },
  ".cm-diagnosticSource": {
    fontSize: "70%",
    opacity: 0.7
  },
  ".cm-lintRange": {
    backgroundPosition: "left bottom",
    backgroundRepeat: "repeat-x",
    paddingBottom: "0.7px"
  },
  ".cm-lintRange-error": { backgroundImage: /* @__PURE__ */ k("#d11") },
  ".cm-lintRange-warning": { backgroundImage: /* @__PURE__ */ k("orange") },
  ".cm-lintRange-info": { backgroundImage: /* @__PURE__ */ k("#999") },
  ".cm-lintRange-hint": { backgroundImage: /* @__PURE__ */ k("#66d") },
  ".cm-lintRange-active": { backgroundColor: "#ffdd9980" },
  ".cm-tooltip-lint": {
    padding: 0,
    margin: 0
  },
  ".cm-lintPoint": {
    position: "relative",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: "-2px",
      borderLeft: "3px solid transparent",
      borderRight: "3px solid transparent",
      borderBottom: "4px solid #d11"
    }
  },
  ".cm-lintPoint-warning": {
    "&:after": { borderBottomColor: "orange" }
  },
  ".cm-lintPoint-info": {
    "&:after": { borderBottomColor: "#999" }
  },
  ".cm-lintPoint-hint": {
    "&:after": { borderBottomColor: "#66d" }
  },
  ".cm-panel.cm-panel-lint": {
    position: "relative",
    "& ul": {
      maxHeight: "100px",
      overflowY: "auto",
      "& [aria-selected]": {
        backgroundColor: "#ddd",
        "& u": { textDecoration: "underline" }
      },
      "&:focus [aria-selected]": {
        background_fallback: "#bdf",
        backgroundColor: "Highlight",
        color_fallback: "white",
        color: "HighlightText"
      },
      "& u": { textDecoration: "none" },
      padding: 0,
      margin: 0
    },
    "& [name=close]": {
      position: "absolute",
      top: "0",
      right: "2px",
      background: "inherit",
      border: "none",
      font: "inherit",
      padding: 0,
      margin: 0
    }
  }
});
function I(t) {
  return t == "error" ? 4 : t == "warning" ? 3 : t == "info" ? 2 : 1;
}
class ce extends Q {
  constructor(e) {
    super(), this.diagnostics = e, this.severity = e.reduce((n, i) => I(n) < I(i.severity) ? i.severity : n, "hint");
  }
  toDOM(e) {
    let n = document.createElement("div");
    n.className = "cm-lint-marker cm-lint-marker-" + this.severity;
    let i = this.diagnostics, o = e.state.facet(T).tooltipFilter;
    return o && (i = o(i)), i.length && (n.onmouseover = () => fe(e, n, i)), n;
  }
}
function de(t, e) {
  let n = (i) => {
    let o = e.getBoundingClientRect();
    if (!(i.clientX > o.left - 10 && i.clientX < o.right + 10 && i.clientY > o.top - 10 && i.clientY < o.bottom + 10)) {
      for (let s = i.target; s; s = s.parentNode)
        if (s.nodeType == 1 && s.classList.contains("cm-tooltip-lint"))
          return;
      window.removeEventListener("mousemove", n), t.state.field(V) && t.dispatch({ effects: L.of(null) });
    }
  };
  window.addEventListener("mousemove", n);
}
function fe(t, e, n) {
  function i() {
    let l = t.elementAtHeight(e.getBoundingClientRect().top + 5 - t.documentTop);
    t.coordsAtPos(l.from) && t.dispatch({ effects: L.of({
      pos: l.from,
      above: !1,
      create() {
        return {
          dom: j(t, n),
          getCoords: () => e.getBoundingClientRect()
        };
      }
    }) }), e.onmouseout = e.onmousemove = null, de(t, e);
  }
  let { hoverTime: o } = t.state.facet(T), s = setTimeout(i, o);
  e.onmouseout = () => {
    clearTimeout(s), e.onmouseout = e.onmousemove = null;
  }, e.onmousemove = () => {
    clearTimeout(s), s = setTimeout(i, o);
  };
}
function me(t, e) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let o of e) {
    let s = t.lineAt(o.from);
    (n[s.from] || (n[s.from] = [])).push(o);
  }
  let i = [];
  for (let o in n)
    i.push(new ce(n[o]).range(+o));
  return E.of(i, !0);
}
const ue = /* @__PURE__ */ K({
  class: "cm-gutter-lint",
  markers: (t) => t.state.field(N)
}), N = /* @__PURE__ */ P.define({
  create() {
    return E.empty;
  },
  update(t, e) {
    t = t.map(e.changes);
    let n = e.state.facet(T).markerFilter;
    for (let i of e.effects)
      if (i.is(v)) {
        let o = i.value;
        n && (o = n(o || [])), t = me(e.state.doc, o.slice(0));
      }
    return t;
  }
}), L = /* @__PURE__ */ w.define(), V = /* @__PURE__ */ P.define({
  create() {
    return null;
  },
  update(t, e) {
    return t && e.docChanged && (t = B(e, t) ? null : Object.assign(Object.assign({}, t), { pos: e.changes.mapPos(t.pos) })), e.effects.reduce((n, i) => i.is(L) ? i.value : n, t);
  },
  provide: (t) => U.from(t)
}), he = /* @__PURE__ */ y.baseTheme({
  ".cm-gutter-lint": {
    width: "1.4em",
    "& .cm-gutterElement": {
      padding: ".2em"
    }
  },
  ".cm-lint-marker": {
    width: "1em",
    height: "1em"
  },
  ".cm-lint-marker-info": {
    content: /* @__PURE__ */ x('<path fill="#aaf" stroke="#77e" stroke-width="6" stroke-linejoin="round" d="M5 5L35 5L35 35L5 35Z"/>')
  },
  ".cm-lint-marker-warning": {
    content: /* @__PURE__ */ x('<path fill="#fe8" stroke="#fd7" stroke-width="6" stroke-linejoin="round" d="M20 6L37 35L3 35Z"/>')
  },
  ".cm-lint-marker-error": {
    content: /* @__PURE__ */ x('<circle cx="20" cy="20" r="15" fill="#f87" stroke="#f43" stroke-width="6"/>')
  }
}), Y = [
  f,
  /* @__PURE__ */ y.decorations.compute([f], (t) => {
    let { selected: e, panel: n } = t.field(f);
    return !e || !n || e.from == e.to ? g.none : g.set([
      ie.range(e.from, e.to)
    ]);
  }),
  /* @__PURE__ */ q(ne, { hideOn: B }),
  ae
], T = /* @__PURE__ */ M.define({
  combine(t) {
    return F(t, {
      hoverTime: 300,
      markerFilter: null,
      tooltipFilter: null
    });
  }
});
function xe(t = {}) {
  return [T.of(t), N, ue, he, V];
}
export {
  D as closeLintPanel,
  xe as lintGutter,
  we as lintKeymap,
  ke as linter,
  se as nextDiagnostic,
  oe as openLintPanel,
  te as setDiagnostics,
  v as setDiagnosticsEffect
};
